import IceBreaker from 'redhotpie-shared-lib/models/iceBreaker';
import * as types from '../constants/actionTypes';
import iceBreakerService from '../services/iceBreakerService';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';

export function loadIceBreakerSuccess(iceBreakers: IceBreaker[]) {
  return { type: types.LOAD_ICE_BREAKER_SUCCESS, iceBreakers };
}

export function loadIceBreakers() {
  return function (dispatch: any) {
    dispatch(beginAjaxCall());
    return iceBreakerService.loadAll().then(res => {
      if (res.success) {
        dispatch(loadIceBreakerSuccess(res.data.items));
      } else {
        console.warn('Error: iceBreakerAction/loadIceBreakers', res.message);
      }
      return res;
    });
  };
}
